module.exports = __webpack_public_path__ + "img/BLANCO_Desarrollo.9436f3a7.png";